import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=7b4b2d9c&"
import script from "./AlertBar.vue?vue&type=script&lang=js&"
export * from "./AlertBar.vue?vue&type=script&lang=js&"
import style0 from "./AlertBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports